/* eslint-disable import/prefer-default-export */
import { JsonServiceConditional, Service } from '@quality24/inpatient-typings';
import { cronCheck } from './cronUtils';

export type CronRule = NonNullable<JsonServiceConditional['cronRule']>;

/**
 *
 * @param conditional
 * @param lastAlertCreation
 * @param notifier called with the error message when the conditional blocks
 * @param resolveMessage builds the error message from the cron rule, letting the
 * client pick the translation from `errorMessageI18N` in its current language.
 * Falls back to `errorMessage` and then to a pt-BR default when it returns
 * nothing.
 * @returns
 */
export const validateConditional = (
  conditional: Service['conditional'],
  lastAlertCreation: string | null,
  notifier?: (message: string) => void,
  resolveMessage?: (cronRule: CronRule) => string | null | undefined,
) => {
  // Cron validation
  const cronRules = conditional?.cronRule;
  if (cronRules) {
    const lastAlertDate = lastAlertCreation
      ? new Date(lastAlertCreation)
      : null;

    const currentDate = new Date();
    const match = cronRules.rules.some((rule) =>
      cronCheck(rule, currentDate, lastAlertDate),
    );

    if (!match) {
      notifier?.(
        resolveMessage?.(cronRules) ||
          cronRules.errorMessage ||
          'Esta categoria de serviço não está disponível para este horário',
      );
      return false;
    }
  }
  return true;
};
